import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { Actions } from '../../../client/Actions';

const GlobalConfigContext = createContext();

export const GlobalConfigProvider = ({ children }) => {
  const [checkinTime, setCheckinTime] = useState(null);
  const [checkoutTime, setCheckoutTime] = useState(null);
  const [paymentOnBooking, setPaymentOnBooking] = useState(null);
  const [paymentOnBookingDueDays, setPaymentOnBookingDueDays] = useState(null);
  const [fullRefundDueDays, setFullRefundDueDays] = useState(null);
  const [partialRefundDueDays, setPartialRefundDueDays] = useState(null);
  const [partialRefundPercentage, setPartialRefundPercentage] = useState(null);
  const [securityDepositAmount, setSecurityDepositAmount] = useState(null);
  const [consentTextAdmin, setConsentTextAdmin] = useState(null);
  const [consentTextClient, setConsentTextClient] = useState(null);
  const [rodoText, setRodoText] = useState(null);
  const [contactDetails, setContactDetails] = useState(null); // 👉 NEW
  const [isLoading, setIsLoading] = useState(true);

  const loadGlobalConfig = useCallback(() => {
    setIsLoading(true);
    Actions.get('globalConfig', (data) => {
      data.forEach((item) => {
        switch (item.key) {
          case 'CHECKIN_TIME':
            setCheckinTime(item.value);
            break;
          case 'CHECKOUT_TIME':
            setCheckoutTime(item.value);
            break;
          case 'PAYMENT_ON_RESERVATION_PERCENTAGE':
            setPaymentOnBooking(parseFloat(item.value));
            break;
          case 'PAYMENT_ON_BOOKING_DUE_DAYS':
            setPaymentOnBookingDueDays(parseInt(item.value));
            break;
          case 'FULL_REFUND_DUE_DAYS':
            setFullRefundDueDays(parseInt(item.value));
            break;
          case 'PARTIAL_REFUND_DUE_DAYS':
            setPartialRefundDueDays(parseInt(item.value));
            break;
          case 'PARTIAL_REFUND_PERCENTAGE':
            setPartialRefundPercentage(parseFloat(item.value));
            break;
          case 'SECURITY_DEPOSIT_AMOUNT':
            setSecurityDepositAmount(parseFloat(item.value));
            break;
          case 'CONSENT_TEXT_ADMIN_RESERVATION':
            setConsentTextAdmin(item.value);
            break;
          case 'CONSENT_TEXT_CLIENT_RESERVATION':
            setConsentTextClient(item.value);
            break;
          case 'RODO_TEXT':
            setRodoText(item.value);
            break;
          case 'CONTACT_DETAILS': // 👉 NEW
            setContactDetails(item.value);
            break;
          default:
            break;
        }
      });
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    loadGlobalConfig();
  }, [loadGlobalConfig]);

  return (
    <GlobalConfigContext.Provider
      value={{
        checkinTime,
        checkoutTime,
        paymentOnBooking,
        paymentOnBookingDueDays,
        fullRefundDueDays,
        partialRefundDueDays,
        partialRefundPercentage,
        securityDepositAmount,
        consentTextAdmin,
        consentTextClient,
        rodoText,
        contactDetails,
        isLoading,
        contextUpdated: loadGlobalConfig,
      }}
    >
      {children}
    </GlobalConfigContext.Provider>
  );
};

export const useGlobalConfig = () => {
  const context = useContext(GlobalConfigContext);
  if (!context) {
    throw new Error('useGlobalConfig must be used within a GlobalConfigProvider');
  }
  return context;
};
